module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data-grade"
  }, [_c('div', {
    staticClass: "view-toggle"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.viewMode
    },
    on: {
      "select": function($event) {
        _vm.viewMode = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.viewMode === 'timer') ? _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "grade-title"
  }, [(_vm.events.length > 0) ? _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isShowMore = !_vm.isShowMore
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-down"
  })]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.calendarName) + "\n        ")])]), _vm._v(" "), _c('th', [_vm._v("Antal skemabrikker")]), _vm._v(" "), _c('th', [_vm._v("Antal skemabrikker med vikar")]), _vm._v(" "), _c('th', [_vm._v("Antal klokketimer")]), _vm._v(" "), _c('th', [_vm._v("Antal klokketimer med vikar")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.events.length))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsWithSub.length))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsInHours))]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.eventsWithSubInHours))]), _vm._v(" "), _c('th')])]), _vm._v(" "), (_vm.isShowMore) ? _c('tbody', _vm._l((_vm.eventsInPools), function(subject, prop) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(prop))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['events']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['eventsWithSubs']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['durationInHours']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject['durationWithSubsInHours']))]), _vm._v(" "), _c('td')])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'subs') ? _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.eventsWithSubInHours || 0))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.substitutesByKlass), function(klass) {
    return _vm._l((klass.substitutes), function(sub) {
      return _c('tr', {
        key: sub.calendarId,
        staticClass: "substitute-item"
      }, [_c('td', [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMinutesToHours(sub.minutes)))])])
    })
  }), _vm._v(" "), (_vm.substitutesByKlass.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Ingen vikarer fundet")])]) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c6982942!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolDataGrade.vue
// module id = 2122
// module chunks = 1